import type { Component, ConcreteComponent, VNodeProps } from 'vue'

// TODO Write tests to ensure that this works correctly
export type ExtractComponentProps<
    TypeOfImportedComp extends
        | Component
        | (() => Component | Promise<{ default: Component }>)
        | Promise<{ default: Component }>,
> = TypeOfImportedComp extends () => Component | Promise<Component>
    ? ExtractComponentProps<ReturnType<TypeOfImportedComp>>
    : TypeOfImportedComp extends Promise<{ default: infer Compo }>
      ? Compo extends Component
          ? ExtractComponentProps<Compo>
          : never
      : TypeOfImportedComp extends new (...args: any) => infer Constructor
        ? Constructor extends { $props: infer Props }
            ? Omit<Props, keyof VNodeProps>
            : never
        : TypeOfImportedComp extends ConcreteComponent<infer PR>
          ? PR
          : never

/** @ts-expect-error although there is error, it works :shrug: */
export const getComponent = <
    C extends Component,
    P extends ExtractComponentProps<C>,
>(
    is: C,
    bind: P
): {
    is: C
    bind: P
} => {
    return {
        is,
        bind,
    }
}
